import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { parseBirthDateInput } from '../utils/birthDateInput';
import './SettingsModal.css';
import './BirthDateRequiredModal.css';

const BirthDateRequiredModal = ({ onComplete }) => {
  const [value, setValue] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const p = parseBirthDateInput(value.trim());
    if (!p.ok) {
      setError(p.error);
      return;
    }
    setSaving(true);
    setError('');
    try {
      const token = localStorage.getItem('token');
      const res = await fetch('/api/auth/birth-date', {
        method: 'PATCH',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ birthDate: p.iso })
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        setError(data.error || 'Не удалось сохранить');
        return;
      }
      if (data.user) {
        onComplete(data.user);
      }
    } catch {
      setError('Ошибка сети');
    } finally {
      setSaving(false);
    }
  };

  const modal = (
    <div className="settings-modal-overlay birth-date-required-overlay" role="dialog" aria-modal="true" aria-labelledby="birth-date-required-title">
      <div className="settings-modal birth-date-required-modal">
        <div className="settings-modal-header birth-date-required-header">
          <h2 id="birth-date-required-title">Укажите дату рождения</h2>
        </div>
        <div className="settings-modal-content">
          <p className="birth-date-required-text">
            Для работы с панелью нужна дата рождения — так команда сможет отмечать дни рождения.
          </p>
          <form onSubmit={handleSubmit} className="birth-date-required-form">
            <label htmlFor="birth-date-required-input" className="birth-date-required-label">
              Дата рождения
            </label>
            <input
              id="birth-date-required-input"
              type="text"
              className="birth-date-required-input"
              placeholder="ДД.ММ.ГГГГ"
              value={value}
              onChange={(e) => {
                setValue(e.target.value);
                setError('');
              }}
              autoComplete="bday"
              disabled={saving}
            />
            {error && <div className="birth-date-required-error">{error}</div>}
            <button type="submit" className="birth-date-required-submit" disabled={saving}>
              {saving ? 'Сохранение...' : 'Сохранить'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );

  return createPortal(modal, document.body);
};

export default BirthDateRequiredModal;
